export default __webpack_public_path__ + "static/media/Europeo.8c85cf16.png";